/*==================================================
  PRODUCT GIVEAWAY POPUP
  Phase 3A
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const popups = document.querySelectorAll(".nb-giveaway");

    if (!popups.length) return;

    popups.forEach(popup => {

        new GiveawayPopup(popup);

    });

});

class GiveawayPopup {

    constructor(root){

        this.root = root;

        this.sectionId = root.dataset.sectionId;

        this.storageKey = `nb-giveaway-${this.sectionId}`;

        this.delay = Number(root.dataset.delay || 3000);

        this.modal = root.querySelector(".nb-giveaway__modal");

        this.overlay = root.querySelector(".nb-giveaway__overlay");

        this.closeBtn = root.querySelector(".nb-giveaway__close");

        this.canvas = root.querySelector(".nb-giveaway__confetti");

        this.isOpen = false;

        this.openTimer = null;

        this.boundClose = this.close.bind(this);

        this.init();

    }

    /*==============================*/

    init(){

        if(sessionStorage.getItem(this.storageKey))
            return;

        this.bindEvents();

        this.startDelay();

    }

    /*==============================*/

    bindEvents(){

        if(this.closeBtn){

            this.closeBtn.addEventListener(
                "click",
                this.boundClose
            );

        }

    }

    /*==============================*/

    startDelay(){

        this.openTimer = window.setTimeout(()=>{

            this.open();

        },this.delay);

    }

    /*==============================*/

    open(){

        if(this.isOpen)
            return;

        this.isOpen = true;

        this.lockBody();

        this.root.classList.add("is-visible");

        /*
            Popup entrance timing

            0ms
            Wrapper fades

            350ms
            Popup finishes spring

            Phase 3B
            Confetti starts here
        */

        window.setTimeout(()=>{

            if(typeof window.nbGiveawayConfetti === "function"){

                window.nbGiveawayConfetti({

                    canvas:this.canvas,

                    modal:this.modal,

                    popup:this.root

                });

            }

        },360);

    }

    /*==============================*/

    close(){

        if(!this.isOpen)
            return;

        this.isOpen = false;

        this.root.classList.remove("is-visible");

        this.unlockBody();

        sessionStorage.setItem(
            this.storageKey,
            "closed"
        );

        if(typeof window.nbDestroyGiveawayConfetti==="function"){

            window.nbDestroyGiveawayConfetti(this.canvas);

        }

    }

    /*==============================*/

    lockBody(){

        document.body.classList.add(
            "nb-popup-open"
        );

    }

    unlockBody(){

        document.body.classList.remove(
            "nb-popup-open"
        );

    }

    /*==============================*/

    destroy(){

        clearTimeout(this.openTimer);

        if(this.closeBtn){

            this.closeBtn.removeEventListener(
                "click",
                this.boundClose
            );

        }

        this.unlockBody();

    }

}

/*==================================================
  CONFETTI ENGINE
  STEP 1
==================================================*/

(() => {

const engines = new WeakMap();

window.nbGiveawayConfetti = function(config){

    const existing = engines.get(config.canvas);

    if(existing){

        existing.destroy();

    }

    const engine = new ConfettiEngine(config);

    engines.set(config.canvas, engine);

    engine.init();

};

window.nbDestroyGiveawayConfetti = function(canvas){

    const engine = engines.get(canvas);

    if(engine){

        engine.destroy();

        engines.delete(canvas);

    }

};

class ConfettiEngine{

    constructor(config){

        this.canvas = config.canvas;

        this.modal = config.modal;

        this.popup = config.popup;

        this.ctx = this.canvas.getContext("2d");

        this.width = 0;

        this.height = 0;

        this.animationFrame = null;

        this.particles = [];

        this.time = 0;

        this.running = false;

        this.finished = false;

        this.lastFrame = 0;

        this.resizeHandler = this.resize.bind(this);

        this.colors = [
            "#006B3F",
            "#00873D",
            "#0C9B4A",
            "#47C97A",
            "#FFFFFF"
        ];

    }

    init(){

        this.resize();

        window.addEventListener(
            "resize",
            this.resizeHandler
        );

        this.running = true;

        this.render();

        this.launch();

    }

    resize(){

        this.width = window.innerWidth;

        this.height = window.innerHeight;

        this.canvas.width = this.width;

        this.canvas.height = this.height;

    }

    render(){

        if(!this.running)
            return;

        this.ctx.clearRect(

            0,

            0,

            this.width,

            this.height

        );

        for(let i=this.particles.length-1;i>=0;i--){

            const particle = this.particles[i];

            particle.update();

            if(particle.dead){

                this.particles.splice(i,1);

                continue;

            }

            particle.draw(this.ctx);

        }

        if(

            this.finished &&

            this.particles.length===0

        ){

            this.destroy();

            return;

        }

        this.animationFrame =

            requestAnimationFrame(

                ()=>this.render()

            );

    }

    launch() {

        const rect = this.modal.getBoundingClientRect();

        const leftEmitter = {
            x: rect.left + 25,
            y: rect.top + rect.height * 0.45
        };

        const rightEmitter = {
            x: rect.right - 25,
            y: rect.top + rect.height * 0.45
        };

        // First burst (70%)
        this.createBurst(leftEmitter, "left", 90);

        this.createBurst(rightEmitter, "right", 90);

        // Second burst (30%)
        setTimeout(() => {

            if (!this.running) return;

            this.createBurst(leftEmitter, "left", 40);

            this.createBurst(rightEmitter, "right", 40);

            this.finished = true;

        }, 200);

    }

    createBurst(origin, side, amount){

        for(let i = 0; i < amount; i++){

            const angle = side === "left"
                ? random(-75, 15)
                : random(165, 255);

            const radians = angle * Math.PI / 180;

            const speed = random(7, 22);

            const particle = createParticle({

                x: origin.x,

                y: origin.y,

                vx: Math.cos(radians) * speed,

                vy: Math.sin(radians) * speed,

                color: randomColor(this.colors),

                size: random(
                    CONFETTI.rectangleMin,
                    CONFETTI.rectangleMax
                ),

                rotation: random(0, Math.PI * 2),

                rotationSpeed: random(-0.25,0.25)

            });

            this.particles.push(particle);

        }

    }

    destroy(){

        this.running = false;

        if(this.animationFrame){

            cancelAnimationFrame(this.animationFrame);

        }

        window.removeEventListener(
            "resize",
            this.resizeHandler
        );

        this.ctx.clearRect(
            0,
            0,
            this.width,
            this.height
        );

        this.particles.length = 0;
        this.canvas.width = 0;
        this.canvas.height = 0;

    }

}

/*==================================================
  PARTICLE
==================================================*/

class Particle{

    constructor(options){

        Object.assign(this, options);

        this.life = 0;

        this.maxLife = CONFETTI.maxLife;

        this.alpha = 1;

        this.dead = false;

        this.rotation = options.rotation || 0;

        this.rotationSpeed = options.rotationSpeed || 0;

        this.wobble = random(0, Math.PI * 2);

        this.wobbleSpeed = random(.03,.12);

        this.scale = 1;

        this.size = options.size || 8;

    }

    update(){

        this.life++;

        if(this.life >= this.maxLife){

            this.dead = true;

            return;

        }

        this.vx *= CONFETTI.drag;

        this.vy += CONFETTI.gravity;

        if(this.vy > CONFETTI.terminalVelocity){

            this.vy = CONFETTI.terminalVelocity;

        }

        this.x += this.vx;

        this.y += this.vy;

        this.rotation += this.rotationSpeed;

        this.wobble += this.wobbleSpeed;

        this.drawX =

            this.x +

            Math.sin(this.wobble) *

            CONFETTI.wobbleAmount *

            (this.vy * 0.15 + 1);

        if(this.life > CONFETTI.fadeStart){

            const remaining =

                this.maxLife -

                this.life;

            this.alpha = Math.max(
                0,
                remaining /
                (this.maxLife - CONFETTI.fadeStart)
            );

        }

    }

    draw(ctx){

        ctx.save();

        ctx.globalAlpha = this.alpha;

        ctx.translate(

            this.drawX,

            this.y

        );

        ctx.rotate(this.rotation);

        ctx.fillStyle = this.color;

        switch(this.type){

            case "rectangle":

                ctx.fillRect(

                    -this.size/2,

                    -this.size/2,

                    this.size,

                    this.size

                );

            break;

            case "circle":

                ctx.beginPath();

                ctx.arc(

                    0,

                    0,

                    this.size*.5,

                    0,

                    Math.PI*2

                );

                ctx.fill();

            break;

            case "ribbon":

                ctx.beginPath();

                ctx.roundRect(

                    -this.size * .6,

                    -2,

                    this.size * 1.2,

                    4,

                    2

                );

                ctx.fill();

            break;

        }

        ctx.restore();

    }

}

class RectangleParticle extends Particle{

    constructor(options){

        super(options);

        this.type = "rectangle";

    }

}

class CircleParticle extends Particle{

    constructor(options){

        super(options);

        this.type = "circle";

    }

}

class RibbonParticle extends Particle{

    constructor(options){

        super(options);

        this.type = "ribbon";

    }

}

function createParticle(options){

    const type = Math.random();

    if(type < 0.50){

        options.size = random(
            CONFETTI.rectangleMin,
            CONFETTI.rectangleMax
        );

        return new RectangleParticle(options);

    }

    if(type < 0.80){

        options.size = random(
            CONFETTI.circleMin,
            CONFETTI.circleMax
        );

        return new CircleParticle(options);

    }

    options.size = random(
        CONFETTI.ribbonMin,
        CONFETTI.ribbonMax
    );

    return new RibbonParticle(options);

}

function randomColor(colors){

    return colors[

        randomInt(

            0,

            colors.length-1

        )

    ];

}

function random(min,max){

    return Math.random() * (max-min) + min;

}

function randomInt(min,max){

    return Math.floor(

        random(min,max+1)

    );

}

const CONFETTI = {

    gravity: 0.28,

    drag:.992,

    wobbleSpeed:.09,

    ribbonMin:18,
    ribbonMax:30,

    rectangleMin:6,
    rectangleMax:12,

    circleMin:3,
    circleMax:7,

    wobbleAmount:2.8,

    terminalVelocity:9,

    fadeStart:140,

    maxLife:220

};

})();